import { useEffect, useState } from "react";
import adminServices from "../services/adminServices";

const DAY_OPTIONS = [7, 30, 90, 180, 365];
const PAGE_SIZE = 25;

// value is sent to the API and matched against status_lk.code ("" = all statuses)
const STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "ACTIVE", label: "Active" },
  // { value: "INACTIVE", label: "Inactive" },
];

const METRICS = [
  { key: "first_test", field: "first_test_completed", label: "Completed first test", hint: "First Test Series completed in this period" },
  { key: "second_test", field: "second_test_taken", label: "Took a second test", hint: "Another Test Series on a later day than their first" },
  // { key: "returning", field: "returning_testers", label: "Returning testers", hint: "Tested in period and also before it" },
  { key: "active", field: "regular_testers", label: "Regular testers", hint: "" },
];

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB") : "—");


const getErrorMessage = (e) =>
  e?.response?.data?.message || e?.response?.data?.error || e?.message || "Request failed";

const CSS = `
.eng { padding: 24px; color: #1f2937; font-size: 14px; line-height: 1.5; font-family: inherit; }
.eng *, .eng *::before, .eng *::after { box-sizing: border-box; }

.eng-header { display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 16px; margin-bottom: 20px; }
.eng-title { margin: 0; font-size: 20px; font-weight: 600; line-height: 1.3; color: #111827; }
.eng-sub { margin: 2px 0 0; font-size: 13px; color: #6b7280; }

.eng-filters { display: flex; align-items: center; flex-wrap: wrap; gap: 16px; }
.eng-field { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #374151; }
.eng-select, .eng-number, .eng-search {
  height: 36px; padding: 0 10px; border: 1px solid #d1d5db; border-radius: 8px;
  background: #fff; font-size: 14px; color: #111827; line-height: 1.5;
}
.eng-select:focus, .eng-number:focus, .eng-search:focus { outline: 2px solid #bfdbfe; border-color: #2563eb; }
.eng-number { width: 64px; }
.eng-search { width: 260px; max-width: 100%; }

.eng-error { margin: 0 0 16px; padding: 10px 14px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; color: #b91c1c; }

.eng-cards { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 16px; margin-bottom: 24px; }
.eng-card {
  display: flex; flex-direction: column; align-items: flex-start; gap: 6px; width: 100%;
  padding: 16px 18px; border: 1px solid #e5e7eb; border-radius: 12px; background: #fff;
  text-align: left; cursor: pointer; transition: border-color .15s, background .15s;
}
.eng-card:hover { border-color: #93c5fd; }
.eng-card.is-selected { border-color: #2563eb; background: #eff6ff; box-shadow: 0 0 0 1px #2563eb; }
.eng-card-label { font-size: 13px; font-weight: 500; line-height: 1.4; color: #4b5563; }
.eng-card-value { font-size: 32px; font-weight: 700; line-height: 1.1; color: #111827; }
.eng-card-hint { min-height: 17px; font-size: 12px; line-height: 1.4; color: #6b7280; }

.eng-panel { border: 1px solid #e5e7eb; border-radius: 12px; background: #fff; overflow: hidden; }
.eng-panel-head { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; padding: 14px 16px; border-bottom: 1px solid #e5e7eb; }
.eng-panel-title { margin: 0; font-size: 15px; font-weight: 600; line-height: 1.4; color: #111827; }
.eng-count { font-weight: 400; color: #6b7280; }
.eng-search-form { display: flex; gap: 8px; }

.eng-btn {
  height: 36px; padding: 0 14px; border: 1px solid #d1d5db; border-radius: 8px;
  background: #fff; font-size: 14px; color: #374151; cursor: pointer;
}
.eng-btn:hover:not(:disabled) { background: #f3f4f6; }
.eng-btn:disabled { opacity: .5; cursor: not-allowed; }
.eng-btn-primary { border-color: #2563eb; background: #2563eb; color: #fff; }
.eng-btn-primary:hover:not(:disabled) { background: #1d4ed8; }

.eng-table-wrap { overflow-x: auto; }
.eng-table { width: 100%; border-collapse: collapse; font-size: 14px; }
.eng-table th {
  padding: 10px 16px; border-bottom: 1px solid #e5e7eb; background: #f9fafb;
  text-align: left; white-space: nowrap; font-size: 12px; font-weight: 600;
  text-transform: uppercase; letter-spacing: .04em; color: #6b7280;
}
.eng-table td { padding: 12px 16px; border-bottom: 1px solid #f3f4f6; white-space: nowrap; color: #1f2937; }
.eng-table tbody tr:hover { background: #f9fafb; }
.eng-table th.eng-num, .eng-table td.eng-num { text-align: right; }
.eng-name { font-weight: 500; }
.eng-empty { padding: 32px 16px !important; text-align: center; color: #6b7280 !important; }

.eng-pager { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; padding: 12px 16px; font-size: 13px; color: #6b7280; }
.eng-pager-controls { display: flex; align-items: center; gap: 12px; }

.eng-badge { display: inline-block; padding: 2px 10px; border-radius: 999px; background: #f3f4f6; color: #374151; font-size: 12px; font-weight: 500; line-height: 1.5; }
.eng-badge-active { background: #dcfce7; color: #166534; }
.eng-badge-inactive { background: #fee2e2; color: #991b1b; }
`;

function UserRows({ loading, users }) {
  if (loading) {
    return (
      <tr><td colSpan={8} className="eng-empty">Loading…</td></tr>
    );
  }
  if (users.length === 0) {
    return (
      <tr><td colSpan={8} className="eng-empty">No users found.</td></tr>
    );
  }
  return (
    <>
      {users.map((u) => (
        <tr key={u.user_id}>
          <td className="eng-name">{u.name || `User #${u.user_id}`}</td>
          <td>{u.email || "—"}</td>
          <td>
            {u.status
              ? <span className={`eng-badge eng-badge-${u.status.toLowerCase()}`}>{u.status}</span>
              : "—"}
          </td>
          <td>{fmtDate(u.first_test_at)}</td>
          <td>{fmtDate(u.second_test_at)}</td>
          <td>{fmtDate(u.last_test_at)}</td>
          <td className="eng-num">{u.assessments_in_window}</td>
          {/* <td className="eng-num">{u.total_assessments}</td> */}
        </tr>
      ))}
    </>
  );
}

export default function EngagementDashboard() {
  const [days, setDays] = useState(30);
  const [activeMin, setActiveMin] = useState(3);
  const [status, setStatus] = useState("");
  const [summary, setSummary] = useState(null);
  const [metric, setMetric] = useState("first_test");
  console.log(metric,"metricmetric");
  
  const [list, setList] = useState({ users: [], total: 0, total_pages: 0 });
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let ignore = false;
    setError("");
    adminServices
      .getEngagementSummary(days, activeMin, status)
      .then((result) => {
        if (!ignore) setSummary(result.data.summary);
      })
      .catch((e) => {
        if (!ignore) setError(getErrorMessage(e));
      });
    return () => { ignore = true; };
  }, [days, activeMin, status]);

  // Complete user list for the selected card
  useEffect(() => {
    let ignore = false;
    setLoading(true);
    adminServices
      .getEngagementUsers(metric, days, activeMin, page, PAGE_SIZE, query, status)
      .then((result) => {
        if (!ignore) setList(result.data);
      })
      .catch((e) => {
        if (!ignore) setError(getErrorMessage(e));
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => { ignore = true; };
  }, [metric, days, activeMin, status, page, query]);

  // Changing any filter returns to page 1 (done in handlers to avoid a wasted request)
  const handleDaysChange = (e) => { setDays(Number(e.target.value)); setPage(1); };
  const handleActiveMinChange = (e) => { setActiveMin(Math.max(1, Number(e.target.value) || 1)); setPage(1); };
  const handleStatusChange = (e) => { setStatus(e.target.value); setPage(1); };
  const handleMetricChange = (key) => { setMetric(key); setPage(1); };
  const handleSearch = (e) => { e.preventDefault(); setQuery(search.trim()); setPage(1); };

  const current = METRICS.find((m) => m.key === metric);
  const total = list.total || 0;
  const from = total === 0 ? 0 : (page - 1) * PAGE_SIZE + 1;
  const to = Math.min(page * PAGE_SIZE, total);

  return (
    <div className="eng">
      <style>{CSS}</style>

      <div className="eng-header">
        <div>
          <h2 className="eng-title">Test Series Tracking</h2>
        </div>
        <div className="eng-filters">
          <label className="eng-field" htmlFor="engagement-days">
            Period
            <select id="engagement-days" className="eng-select" value={days} onChange={handleDaysChange}>
              {DAY_OPTIONS.map((d) => <option key={d} value={d}>Last {d} days</option>)}
            </select>
          </label>
          <label className="eng-field" htmlFor="engagement-status">
            Status
            <select id="engagement-status" className="eng-select" value={status} onChange={handleStatusChange}>
              {STATUS_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </label>

        {metric === 'active' &&
          <label className="eng-field" htmlFor="engagement-active-min">
            Regular = at least
            <input
              id="engagement-active-min"
              className="eng-number"
              type="number"
              min={1}
              max={100}
              value={activeMin}
              onChange={handleActiveMinChange}
            />
            Test Series
          </label>}


        </div>
      </div>

      {error && <p className="eng-error">{error}</p>}

      <div className="eng-cards">
        {METRICS.map((m) => {
          const selected = m.key === metric;
          return (
            <button
              key={m.key}
              type="button"
              className={selected ? "eng-card is-selected" : "eng-card"}
              onClick={() => handleMetricChange(m.key)}
            >
              <span className="eng-card-label">{m.label}</span>
              <span className="eng-card-value">{summary ? summary[m.field] : "…"}</span>
              <span className="eng-card-hint">
                {m.key === "active" ? `${activeMin}+ different Test Series in period` : m.hint}
              </span>
            </button>
          );
        })}
      </div>

      <div className="eng-panel">
        <div className="eng-panel-head">
          <h3 className="eng-panel-title">
            {current.label} <span className="eng-count">— {total} users</span>
          </h3>
          <form className="eng-search-form" onSubmit={handleSearch}>
            <input
              className="eng-search"
              aria-label="Search by name or email"
              placeholder="Search name or email"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button type="submit" className="eng-btn eng-btn-primary">Search</button>
          </form>
        </div>

        <div className="eng-table-wrap">
          <table className="eng-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Status</th>
                <th>First test</th>
                <th>Second test</th>
                <th>Last test</th>
                <th className="eng-num">Test Series in period</th>
                {/* <th className="eng-num">Total Test Series</th> */}
              </tr>
            </thead>
            <tbody>
              <UserRows loading={loading} users={list.users} />
            </tbody>
          </table>
        </div>

        <div className="eng-pager">
          <span>{total === 0 ? "No results" : `Showing ${from}–${to} of ${total}`}</span>
          <div className="eng-pager-controls">
            <button type="button" className="eng-btn" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>Previous</button>
            <span>Page {page} of {Math.max(list.total_pages, 1)}</span>
            <button type="button" className="eng-btn" disabled={page >= list.total_pages} onClick={() => setPage((p) => p + 1)}>Next</button>
          </div>
        </div>
      </div>
    </div>
  );
}